import { MAX_UPLOAD_SIZE_MB, MAX_UPLOAD_SIZE_BYTES } from '../constants/appConstants';

export const validateFileSize = (file) => {
  if (!file) return null;
  if (file.size > MAX_UPLOAD_SIZE_BYTES) {
    const sizeInMB = (file.size / (1024 * 1024)).toFixed(1);
    return `File size (${sizeInMB}MB) exceeds the maximum limit of ${MAX_UPLOAD_SIZE_MB}MB.`;
  }
  return null;
};

export const normalizeUploadResponse = (response) => {
  if (!response) return null;

  const data = response.data || response;

  if (data.Location) return data.Location;
  if (data.previewUrl) return data.previewUrl;
  if (data.url) return data.url;
  if (data.downloadUrl) return data.downloadUrl;

  if (data.files && data.files.length > 0) {
    if (data.files[0].url) return data.files[0].url;
    if (data.files[0].previewUrl) return data.files[0].previewUrl;
  }

  return null;
};
